module.exports = __webpack_public_path__ + "media/images/landing/USA-matrimony-banner3_1800-4ed2b837b290a1873bde4cb74e6a4779.webp";